export enum SectorIdentifier {
  Transport = 1000,
  Industry = 1001,
  Agriculture = 1002,
  Energy = 1003,
  Other = 1004,
}
